import React from 'react';
import Paragraphs from './Paragraphs';
import Button from './Button';
import Spacer from './Spacer';

let RegularBlock = ({
  data,
  blockPadding,
  breakout,
  bg,
  textLight,
  textPaddingTop,
  h3Heading,
  h4Heading,
  sectionId,
  cta
}) => {
  let { list, heading, text } = data;
  let InnerContent = () => (
    <React.Fragment>
      {h4Heading ? (
        <h4 style={{ fontSize: '1.3em' }}>{heading}</h4>
      ) : h3Heading ? (
        <h3>{heading}</h3>
      ) : (
        <h2 className="heading blue center">{heading}</h2>
      )}
      {list &&
        list.length > 0 &&
        list.map((listItem, index) => (
          <div style={{ paddingTop: '20px' }} key={index}>
            <h3>{listItem.heading}</h3>
            <Paragraphs data={listItem.text} />
          </div>
        ))}
      {text && (
        <React.Fragment>
          <Spacer px={textPaddingTop} />
          <Paragraphs className="para" data={text} light={textLight} />
        </React.Fragment>
      )}
      <Spacer px={15} />
      {cta &&
        cta.length > 0 &&
        cta.map((btn, btnId) => <Button key={btnId} {...btn} />)}
    </React.Fragment>
  );

  return (
    <section
      id={sectionId}
      className={`regular-block ${breakout ? 'breakout' : ''}`}
      style={{
        padding: blockPadding ? blockPadding : '40px 0',
        backgroundColor: bg
      }}
    >
      {breakout ? (
        <div className="container">
          <InnerContent />
        </div>
      ) : (
        <InnerContent />
      )}
    </section>
  );
};

export default RegularBlock;
